import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 订单类型
 */
class OrderType extends UltMeta {
    /**
     * 寄售商品
     */
    CONSIGNMENT_PRODUCTS = new Meta(1, "寄售商品");
    /**
     * 团购商品
     */
    GROUP_BUYING_PRODUCTS = new Meta(2, "团购商品");
    /**
     * 捡漏商品
     */
    PICKING_UP_MISSING_PRODUCTS = new Meta(3, "捡漏商品");
}
export const ORDER_TYPE = new OrderType();

/**
 * 订单类型PC
 */
class OrderTypePC extends UltMeta {
    ALL = new Meta(0, "全部订单");

    CONSIGNMENT_PRODUCTS = new Meta(1, "寄售");

    GROUP_BUYING_PRODUCTS = new Meta(2, "团购");

    PICKING_UP_MISSING_PRODUCTS = new Meta(3, "捡漏");
    ACTIVITY_PRODUCTS = new Meta(4, "活动");
}
export const ORDER_TYPE_PC = new OrderTypePC();

/**
 * 订单状态
 * */
class OrderState extends UltMeta {
    OBLIGATION = new Meta(1, "待付款");

    PENDING_CONFIRMC = new Meta(6, "待确认支付");

    TO_BE_PICKED_UP = new Meta(2, "待提货");

    IN_THE_PROCESS_OF_PICKING_UP_THE_GOODS = new Meta(3, "提货中");

    COMPLETED = new Meta(4, "已完成");

    CANCELLED = new Meta(5, "已取消");

    GROUPING = new Meta(7, "拼团中");
    
    HELPING = new Meta(8, "助力中");

    UNKNOWN = new Meta(0, "--");
}
export const TRADE_ORDER_STATE = new OrderState();

/**
 * 订单状态PC
 * */
class OrderStatePC extends UltMeta {
    ALL = new Meta(0, "全部");

    GROUPING_HELPING = new Meta(-1, "拼团中/助力中");

    HELPING = new Meta(8, "助力中");

    OBLIGATION = new Meta(1, "待付款");

    PENDING_CONFIRM = new Meta(6, "待确认支付");

    GROUPING = new Meta(7, "拼团中");
    
    TO_BE_PICKED_UP = new Meta(2, "待提货");

    IN_THE_PROCESS_OF_PICKING_UP_THE_GOODS = new Meta(3, "提货中");

    COMPLETED = new Meta(4, "交易完成");

    CANCELLED = new Meta(5, "已取消");
}
export const TRADE_ORDER_STATE_PC = new OrderStatePC();

/**
 * 订单详情tab
 */
class OrderDetailTab extends UltMeta {
    ORDER_MESSAGE = new Meta(1, "订单信息");

    COLLECTION_HISTORY = new Meta(2, "收款记录");

    REFUND_HISTORY = new Meta(4, "退款信息");

    INVOICE_INFO = new Meta(5, "发票信息");

    DELIVERY_MANAGE = new Meta(3, "提货明细");
}

export const ORDER_DETAIL_TAB = new OrderDetailTab();

/**
 * 用户PC订单详情tab
 */
class OrderDetailTabPC extends UltMeta {
    PAYMENT_HISTORY = new Meta(1, "付款记录");

    REFUND_HISTORY = new Meta(5, "退款信息");

    INVOICE_INFO = new Meta(6, "发票信息");

    ORDER_MESSAGE = new Meta(2, "订单信息");

    DELIVERY_MANAGE = new Meta(3, "提货明细");

    PRODUCT_INFO = new Meta(4, "商品信息");
}

export const ORDER_DETAIL_TAB_PC = new OrderDetailTabPC();

/**
 * 订单详情tab
 */
class DeliveryDetailTab extends UltMeta {
    DELIVERY_MESSAGE = new Meta(1, "提货信息");

    COLLECTION_HISTORY = new Meta(2, "收款记录");

    CORROBORATION = new Meta(3, "佐证材料");

    LOGISTICS_TRUCK = new Meta(4, "物流跟踪");
}

export const DELIVERY_DETAIL_TAB = new DeliveryDetailTab();

/**
 * PC订单详情tab
 */
class DeliveryDetailTabPC extends UltMeta {
    DELIVERY_MESSAGE = new Meta(1, "提货信息");

    COLLECTION_HISTORY = new Meta(2, "付款记录");

    CORROBORATION = new Meta(3, "佐证材料");

    LOGISTICS_TRUCK = new Meta(4, "物流跟踪");
}

export const DELIVERY_DETAIL_TAB_PC = new DeliveryDetailTabPC();

/**
 * 是否过滤有支付成功金额
 */
class FilterPayFlag extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(0, "否");
}
export const FILTER_PAY_FLAG = new FilterPayFlag();

/**
 * 订单状态小程序
 * */
class OrderStateMiniApp extends UltMeta {

    ALL = new Meta(0, "全部");

    HELPING = new Meta(8, "助力中", "icon-zhulizhong-xiangqingzhuangtai");


    GROUPING_OR_HELPING = new Meta(99, "拼团中/助力中");

    OBLIGATION = new Meta(1, "待付款", "icon-daifukuan-xiangqingzhuangtai");

    PENDING_CONFIRM = new Meta(6, "待确认支付", "icon-daifukuan-xiangqingzhuangtai");

    GROUPING = new Meta(7, "拼团中", "icon-pintuanzhong-xiangqingzhuangtai");

    TO_BE_PICKED_UP = new Meta(2, "待提货", "icon-daitihuo-xiangqingzhuangtai");

    IN_THE_PROCESS_OF_PICKING_UP_THE_GOODS = new Meta(3, "提货中", "icon-tihuozhong-xiangqingzhuangtai");

    COMPLETED = new Meta(4, "交易成功", "icon-yiwancheng-xiangqingzhuangtai");

    CANCELLED = new Meta(5, "已取消", "icon-yiquxiao-xiangqingzhuangtai");
}
export const TRADE_ORDER_STATE_MINI_APP = new OrderStateMiniApp();

/**
 * 订单来源
 */
class OrderOrigin extends UltMeta {
    PC = new Meta(1, "pc端");
    MINI_APP = new Meta(2, "小程序端");
    MINI_APP_SHIP = new Meta(3, "小程序船务端");
    IOS_APP = new Meta(4, "IOS端");
    IOS_APP_SHIP = new Meta(5, "IOS船务端");
    ANDROID_APP = new Meta(6, "ANDROID端");
    ANDROID_APP_SHIP = new Meta(7, "ANDROID船务端");
    PC_SHIP = new Meta(8, "PC船务端");
}

export const ORDER_ORIGIN = new OrderOrigin();

/**
 * 订单过滤  1:过滤 0:不过滤
 */
class OrderFiltering extends UltMeta {
    FILTER = new Meta(1, "过滤");
    NO_FILTER = new Meta(0, "不过滤");
}

export const ORDER_FILTERING = new OrderFiltering();

/**
 * 支付类型
 */
class OrderPayType extends UltMeta {
    ONLINE = new Meta(1, "线上支付");
    OFFLINE = new Meta(2, "线下支付");
}
export const ORDER_PAY_TYPE = new OrderPayType();

/**
 * 订单价格类型
 */
class OrderPriceType extends UltMeta {
    PRICE_FIXED = new Meta(1, "固定价格");
    PRICE_ESTIMATED = new Meta(2, "预估价格");
}
export const ORDER_PRICE_TYPE = new OrderPriceType();

/**
 * 捡漏是否结束
 */
class BargainEndFlag extends UltMeta {
    NO = new Meta(0, "否");
    YES = new Meta(1, "是");
}
export const BARGAIN_END_FLAG = new BargainEndFlag();


/**
 * 订单创建来源
 */
class OrderCreateSource extends UltMeta {
    CUSTOMER = new Meta(1, "客户");
    ADMIN = new Meta(2, "后台");
}
export const ORDER_CREATE_SOURCE = new OrderCreateSource();

/**
 * 订单审核状态
 */
class OrderAuditState extends UltMeta {
    TO_SUBMIT = new Meta(0, "待提交");
    PENDING = new Meta(1, "待审核");
    APPROVED = new Meta(2, "已通过");
    REJECTED = new Meta(3, "未通过");
}
export const ORDER_AUDIT_STATE = new OrderAuditState();